/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclinedQuoteResource
 */
export interface DeclinedQuoteResource {
    /**
     * 
     * @type {string}
     * @memberof DeclinedQuoteResource
     */
    quoteId: string;
}

/**
 * Check if a given object implements the DeclinedQuoteResource interface.
 */
export function instanceOfDeclinedQuoteResource(value: object): value is DeclinedQuoteResource {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    return true;
}

export function DeclinedQuoteResourceFromJSON(json: any): DeclinedQuoteResource {
    return DeclinedQuoteResourceFromJSONTyped(json, false);
}

export function DeclinedQuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclinedQuoteResource {
    if (json == null) {
        return json;
    }
    return {
        
        'quoteId': json['quoteId'],
    };
}

export function DeclinedQuoteResourceToJSON(value?: DeclinedQuoteResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quoteId': value['quoteId'],
    };
}

